import { gql } from "@apollo/client";

export const FeatureGridQuery = gql`
  query FeatureGrid($orgRelayId: ID!) {
    node(id: $orgRelayId) {
      id
      ... on Org {
        featureGrid {
          __typename
          ... on FeatureGrid {
            featureStates {
              freePaidFeatures {
                autopilotWhenOrganizerCurrentlyAllowed
                moveRangesEnabled
              }
              meetingReliefSettingVisibility
            }
            stateMetadata {
              primaryBillingGroupMetadata {
                subscription {
                  id
                  type
                  productType
                }
              }
              userMetadata {
                person {
                  primaryCalendarId
                }
                trialMetadata {
                  trialEndDate
                  timeZone
                  isTrialExpired
                }
              }
            }
          }
          ... on GraphEntityError {
            statusCode
            message
          }
        }
      }
    }
  }
`;
